export const COMMISSIONS_OUTPUTS_ROUTE_PREFIX = "/commissions/outputs";

export const COMMISSIONS_OUTPUTS_PATHS = {
  list: { path: "*", to: COMMISSIONS_OUTPUTS_ROUTE_PREFIX },
};
